import React from 'react';
import { Pagination as PaginationComponent, PaginationProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { getRecordCountLabel } from '../utils/pagination';
import { Spinner } from './Spinner';

interface IPaginationProps extends PaginationProps {
  isCountLoading?: boolean;
}

const CustomPagination = styled(PaginationComponent)`
  .ant-pagination-item-active a,
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a,
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #00b27b;
  }
  .ant-pagination-item-active,
  .ant-pagination-options-quick-jumper input:hover {
    border-color: #00b27b;
  }
  .ant-pagination-options-quick-jumper input:focus,
  .ant-pagination-options-quick-jumper input-focused {
    box-shadow: none;
    border-radius: 3px;
  }
  .ant-pagination-total-text {
    color: #818181;
    margin-right: 16px;
    flex-shrink: 0;
  }
  display: flex;
  justify-content: flex-end;
  flex-shrink: 1;
  margin: 30px 0 10px;
`;

const TotalText = styled.span`
  display: inline-flex;
  align-items: center;
`;

const CountLoader = styled(Spinner)`
  margin-left: 8px;
  line-height: 1;
`;

const Pagination = ({
  className = '',
  total,
  isCountLoading = false,
  ...props
}: IPaginationProps) => {
  const renderTotal = (records: number, range: [number, number]) => (
    <TotalText>
      {records ? <span>{getRecordCountLabel(records, range)}</span> : null}
      {isCountLoading && (
        <CountLoader
          data-testid='row-count-loader'
          size='small'
          spinning
          indicator={<LoadingOutlined style={{ fontSize: 14 }} spin />}
        />
      )}
    </TotalText>
  );

  return (
    <CustomPagination
      {...props}
      total={total}
      className={className}
      showSizeChanger={false}
      size='small'
      showQuickJumper
      showTotal={total || isCountLoading ? renderTotal : undefined}
    />
  );
};

export default Pagination;
